import { gql } from "@apollo/client";

const GET_LANGUAGE_DETAILS = gql`
  query LanguageDetails($id: ID!) {
    languageDetails(id: $id) {
      id
      englishName
      realName
      bannerBackground
      oneOnOneCredit
      smallGroupCredit
      cities {
        id
        name
      }
      levels {
        id
        title
        description
      }
    }
  }
`;

export default GET_LANGUAGE_DETAILS;
